import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'separator';
var MARGIN_SIZE = {
  S: 's',
  M: 'm',
  L: 'l',
  none: 'none'
};
var POSITION = {
  INITIAL: 'initial',
  CENTER: 'center',
  END: 'end'
};
var SeparatorWrapper = aggregatedClasses('div')('separator-wrapper', null, function (_ref) {
  var _ref2;

  var margin = _ref.margin,
      orientation = _ref.orientation,
      dashed = _ref.dashed,
      position = _ref.position;
  return _ref2 = {
    dashed: dashed
  }, _defineProperty(_ref2, margin, margin), _defineProperty(_ref2, orientation, orientation), _defineProperty(_ref2, position, position), _ref2;
});
var Separator = aggregatedClasses('div')(blockName, null, function (_ref3) {
  var _ref4;

  var dashed = _ref3.dashed,
      margin = _ref3.margin,
      orientation = _ref3.orientation,
      type = _ref3.type;
  return _ref4 = {
    dashed: dashed
  }, _defineProperty(_ref4, margin, margin), _defineProperty(_ref4, orientation, orientation), _defineProperty(_ref4, type, type), _ref4;
});
var types = ['category-level', 'group-level', 'non-form'];

var DSSeparator = function DSSeparator(_ref5) {
  var containerProps = _ref5.containerProps,
      dashed = _ref5.dashed,
      margin = _ref5.margin,
      orientation = _ref5.orientation,
      type = _ref5.type,
      position = _ref5.position,
      className = _ref5.className,
      style = _ref5.style;
  return /*#__PURE__*/React.createElement(SeparatorWrapper, _extends({}, containerProps, {
    className: className,
    classProps: {
      margin: margin,
      orientation: orientation,
      dashed: dashed,
      position: position
    },
    style: style
  }), /*#__PURE__*/React.createElement(Separator, {
    classProps: {
      dashed: dashed,
      margin: margin,
      orientation: orientation,
      type: type
    }
  }));
};

DSSeparator.defaultProps = {
  containerProps: {},
  dashed: false,
  margin: MARGIN_SIZE.S,
  orientation: 'horizontal',
  type: 'category-level',
  position: POSITION.INITIAL
};
var props = {
  /** class for separator */
  className: PropTypes.string.description('class for separator'),

  /** style object for separator */
  style: PropTypes.object.description('style object for separator'),

  /** Injected props to wrapper element of component */
  containerProps: PropTypes.object.description('Injected props to wrapper element of component'),

  /**
   * If the separator has to be dashed or solid
   */
  dashed: PropTypes.bool.description('If the separator has to be dashed or solid'),

  /**
   * Amount of margin to be added to the separator
   */
  margin: PropTypes.oneOf(['s', 'm', 'l', 'none']).description('Amount of margin to be added to the separator'),

  /**
   * Orientation 'horizontal' or 'vertical'
   */
  orientation: PropTypes.string.description("Orientation 'horizontal' or 'vertical'"),

  /**
   * ['category-level', 'group-level', 'non-form']
   */
  type: PropTypes.oneOf(types).description("['category-level', 'group-level', 'non-form']"),

  /**
   * ['initial', 'center', 'end']
   */
  position: PropTypes.oneOf(['initial', 'center', 'end']).description("['initial', 'center', 'end']")
};
DSSeparator.propTypes = props;
var DSSeparatorWithSchema = describe(DSSeparator);
DSSeparatorWithSchema.propTypes = props;

export default DSSeparator;
export { DSSeparator, DSSeparatorWithSchema };
//# sourceMappingURL=DSSeparator.js.map
